<template>
  <div class="container">
    <div class="title">申请注册</div>
    <div class="sub-title">注册申请提交后工作人员将联系您，协助您完成注册操作</div>
    <!--表单-->
    <van-form
      ref="formRef"
      class="form-wrap"
      validate-first
      show-error
      :show-error-message="false"
      validate-trigger="onSubmit"
      @submit="onSubmit"
    >
      <van-cell-group class="form-cell-group" inset>
        <van-field
          v-model="formData.merchantName"
          name="merchantName"
          label="姓名"
          maxlength="10"
          :placeholder="merchantNameValidText"
          :rules="[{ required: true, validator: validatorName }]"
        />
        <van-field
          v-model="formData.merchantMobile"
          name="merchantMobile"
          label="手机号"
          type="tel"
          maxlength="11"
          :placeholder="merchantMobileValidText"
          :rules="[{ required: true, validator: validatorMobile }]"
        />
        <van-field
          v-model="formData.smsCode"
          name="smsCode"
          label="验证码"
          type="tel"
          maxlength="4"
          :placeholder="codeValidText"
          :rules="[{ required: true, validator: validatorCode }]"
        >
          <template #button>
            <div class="get-code-wrap" @click="onGetCode">
              <van-count-down
                ref="countDown"
                :time="time"
                :auto-start="false"
                @finish="onFinish"
                @change="onChange"
              >
                <div :class="['code-text', disable ? 'disbled' : '']">{{ countDownText }}</div>
              </van-count-down>
            </div>
          </template>
        </van-field>
        <van-field
          v-model="areaShowText"
          label="意向开店区域"
          readonly
          clickable
          placeholder="请选择"
          :rules="[{ required: true, validator: validArea }]"
          @click="showAreaPicker.show = true"
        />
        <van-field
          v-model="formData.remark"
          rows="2"
          autosize
          type="textarea"
          maxlength="100"
          placeholder="备注说明"
          show-word-limit
        />
      </van-cell-group>
      <div class="btn-wrap">
        <van-button class="submit-btn" block native-type="submit">立即注册</van-button>
      </div>
    </van-form>
    <!--意向区域选择器-->
    <van-popup
      v-model:show="showAreaPicker.show"
      round
      position="bottom"
      :lock-scroll="false"
      @open="getAreaList"
    >
      <van-picker
        ref="areaPicker"
        title="选择地区"
        item-height="34"
        :loading="showAreaPicker.loading"
        :columns="showAreaPicker.columns"
        @cancel="showAreaPicker.show = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue';
import { Toast } from 'vant';
import requestApi from './api/index';
import { useRoute, useRouter } from 'vue-router';
import { routerBack } from 'platform-lib-app';

const route = useRoute();

const router = useRouter();

// 路由参数
const routeQuery = route.query;

// 表单对象
const formRef = ref(null);

const areaPicker = ref(null);

// 表单数据
const formData = reactive({
  merchantName: '',
  merchantMobile: '',
  smsCode: '',
  provinceCode: '',
  cityCode: '',
  areaCode: '',
  remark: '',
  sourceCode: ''
});

// 姓名校验结果
const merchantNameValidText = ref('请输入姓名');

// 手机号校验结果
const merchantMobileValidText = ref('请输入手机号');

// 验证码校验结果
const codeValidText = ref('请输入验证码');

// 校验姓名
const validatorName = (val) => {
  const reg = /^[\u4E00-\u9FA5A-Za-z]+$/;
  if (!reg.test(val)) {
    formData.merchantName = '';
    merchantNameValidText.value = '姓名有误';
    return false;
  }
  return true;
};

// 校验手机号
const validatorMobile = (val) => {
  const reg = /^1[3-9]\d{9}$/;
  if (!reg.test(val)) {
    formData.merchantMobile = '';
    merchantNameValidText.value = '手机号有误';
    return false;
  }
  return true;
};

// 校验验证码
const validatorCode = (val) => {
  const reg = /[0-9]{4}/;
  if (!reg.test(val)) {
    formData.smsCode = '';
    codeValidText.value = '验证码有误';
    return false;
  }
  return true;
};

// 校验意向区域
const validArea = () => {
  return !!formData.provinceCode;
};

// 省市区显示文本
const areaShowText = ref('');

// 是否显示区域选择器
const showAreaPicker = reactive({
  show: false,
  columns: [],
  loading: true
});

// 定时器
const countDown = ref(null);

// 倒计时
const time = ref(60000);

// 是否不可点击
const disable = ref(false);

// 获取验证码文本
const countDownText = ref('获取验证码');

// 倒计时结束事务
const onFinish = () => countDown.value.reset();

// 获取验证码
const onGetCode = () => {
  if (disable.value) return;

  formRef.value.validate('merchantMobile').then(() => {
    countDown.value.start();
    const params = {
      mobile: formData.merchantMobile
    };
    requestApi.getCode(params).then(res => {
      const { busCode, busMessage } = res;
      if (busCode === '1') {
        Toast('验证码发送成功');
      } else {
        Toast(busMessage);
        onFinish();
        onChange({seconds: 0, milliseconds: 0});
      }
    }).catch(() => {
      Toast('发送验证码异常，请稍后重试');
      onFinish();
      onChange({
        seconds: 0,
        milliseconds: 0
      });
    });
  });
};

// 获取意向区域
const getAreaList = () => {
  requestApi.getAreas().then((res) => {
    const { busCode, data, busMessage } = res;
    if (busCode === '1') {
      const areaList = [];
      data.map((item) => {
        const province = {
          text: item.name,
          mdCode: item.mdCode,
          children: []
        };
        if (item.children && item.children.length) {
          item.children.map((cItem) => {
            const city = {
              text: cItem.name,
              mdCode: cItem.mdCode,
              children: []
            };
            if (cItem.children && cItem.children.length) {
              cItem.children.map((cArea) => {
                const area = {
                  text: cArea.name,
                  mdCode: cArea.mdCode,
                };
                city.children = city.children || [];
                city.children.push(area);
              });
            }
            province.children = province.children || [];
            province.children.push(city);
          });
        }
        areaList.push(province);
      });
      areaPicker.value.setIndexes([0]);
      showAreaPicker.columns = areaList;
      showAreaPicker.loading = false;
    } else {
      Toast(busMessage);
    }
  });
};

// 倒计时时间改变事务
const onChange = ({seconds, milliseconds}) => {
  const isEnd = seconds === 0 && milliseconds === 0;
  disable.value = !isEnd;
  countDownText.value = isEnd ? '重新发送' : `重新发送 (${seconds})`;
};

// 区域选择事件回调
const onConfirm = ([province, city, area]) => {
  const { text: provinceText, mdCode: provinceMdCode } = province;
  const { text: cityText, mdCode: cityMdCode } = city;
  const { text: areaText, mdCode: areaMdCode } = area || { text: '', mdCode: null };
  formData.provinceCode = provinceMdCode;
  formData.cityCode = cityMdCode;
  formData.areaCode = areaMdCode;
  areaShowText.value = `${provinceText} ${cityText} ${areaText}`;
  showAreaPicker.show = false;
};

// 提交
const onSubmit = () => {
  Toast.loading({
    duration: 0,
    message: '提交中...',
    forbidClick: true,
  });
  const params = { ...formData };
  requestApi.addIntention(params).then(res => {
    const { busCode, busMessage } = res;
    if (busCode === '1') {
      Toast('提交成功,工作人员将在近期与您联系');
      onFinish();
      onChange({
        seconds: 0,
        milliseconds: 0
      });
      setTimeout(() => {
        routerBack();
      }, 1000);
    } else {
      Toast(busMessage);
    }
  });
};

onMounted(() => {
  formData.sourceCode = routeQuery?.sourceCode;
});

</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
  background: #F4F5F7;
  box-sizing: border-box;
  padding: 30px 16px;
  .title {
    font-size: 18px;
    font-weight: 500;
    width: 100%;
    text-align: center;
  }
  .sub-title {
    font-size: 14px;
    margin-top: 24px;
    width: 100%;
    text-align: center;
  }
  .form-wrap {
    margin-top: 24px;
    .form-cell-group {
      margin: 0;
      .code-text {
        color: #E45D50;
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
        &.disbled {
          cursor: not-allowed;
          color: #666666;
        }
      }
    }
  }
  .btn-wrap {
    position: fixed;
    left: 0;
    bottom: 34px;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    padding-bottom: $safe-area-inset-bottom !important;
    .submit-btn {
      color: #ffffff;
      font-weight: 600;
      background-color: #E45D50;
      border-radius: 2px;
      font-size: 18px;
      border: none;
    }
  }
}
</style>
